import { render, staticRenderFns } from "./NumberAvatar.vue?vue&type=template&id=9b479446&scoped=true"
import script from "./NumberAvatar.vue?vue&type=script&lang=js"
export * from "./NumberAvatar.vue?vue&type=script&lang=js"
import style0 from "./NumberAvatar.vue?vue&type=style&index=0&id=9b479446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b479446",
  null
  
)

export default component.exports